<template>
  <div class="container mt-3">
      <!--<h1>Hola mundo vue</h1>

      <div v-if="exampleVariable">
        <p>{{ exampleVariable }}:</p>
      </div>
      <a :href="vueLearn.url" target="_blank">
        {{ vueLearn.titulo }}
      </a>-->

      <!--<a :href="vueLearn.url" target="_blank">
        {{ vueLearn.titulo }}
      </a>

      <div>
        <input v-model="nombre" type="text" class="form-control" placeholder="Nombre">
        <h5>{{ nombre }}</h5>
      </div>
-->

    <h1>“Un Gobierno con finanzas sanas”</h1>

    <div class="d-flex justify-content-between">
      <video :src="urlServe + 'reunion/informacion/1.mp4'" controls width="360"></video>
      <div class="px-5"><p class="text-justify">El Gobierno de Chiapas, encabezado por Rutilio Escandón Cadenas, tuvo el compromiso de impulsar el uso racional y responsable de los recursos públicos, mediante la aplicación de políticas de austeridad, racionalidad y disciplina del gasto público, encaminadas a la eliminación de gastos ostentosos e innecesarios, y a la aplicación de proyectos y acciones que atendieran las prioridades reales de desarrollo de la población chiapaneca, brindando confianza y seguridad en el manejo de las finanzas públicas.</p></div>
    </div>

<hr>
    <div class="d-flex flex-wrap mt-5">
      <img src="@/assets/imagenes/iconos/icono-pdf.png" class="pdfstyle">

      <div class="px-5 py-1">
        <h2>Acciones Relevantes de la Secretaría de Hacienda 2018-2024</h2>
        <p class="text-justify"> Formato: PDF<br>
            Tamaño: 897 kb<br>
            Fecha de actualización: 25/11/2024</p>
            <!--<i class="bx bx-download bx-fade-down-hover"></i> <a :href="urlServe + 'reunion/informacion/acciones-2018-2024.pdf'" target="_blank"><b>Descargar</b></a>-->
            <p data-v-50c6fb40="" class="descargando"><a :href="urlServe + 'reunion/informacion/acciones-2018-2024.pdf'" target="_blank"><b>Descargar </b> </a><i data-v-50c6fb40="" class="bx bx-download icono-down"></i></p>
      </div>
    </div>

    <div class="row">
							<div class="col">
								<div class="media">
                                        <img src="assets/content/icono-pdf.png" class="align-self-start mr-3" alt="PDF">
									<div class="media-body">
										<h5 class="mt-0">Acciones Relevantes de la Secretaría de Hacienda 2018-2024</h5>
									<p>	Formato: PDF<br>
                                   Tamaño: 897 kb<br>
									Fecha de actualización: 25/11/2024</p>

                  <i class="icon-communication-038 u-line-icon-pro u-line-icon-pro g-color-secondary g-mt-5 g-mr-10"></i> <a class="card-link" href="informacion/acciones-2018-2024.pdf"><b>Descargar</b></a>
									</div>
								</div>
							</div>
						</div>
  </div>
</template>


<!--script del titulo-->
<script>
export default {
  data() {
    return{
      /* aqui declaracion de variables globales */
      exampleVariable: 'aprender vue',
      nombre: '',
      vueLearn: {
        titulo: 'Documentación vue español aquí',
        url: 'https://es.vuejs.org/v2/guide/'
      }
    }
  },
  methods:{
    /* aqui declaracion de funciones */
  },
  created(){
    /* codigo q se ejecuta automaticamente al iniciar la vista */
  },
  mounted(){
    /* codigo q se ejecuta automaticamente al terminar de renderizar la vista la vista */
  },
}
</script>
<!--fin del script-->


<style scoped>
  /* aqui el css */
  h1
  {
color: brown;
text-align: center;
font-weight: bold;
font-size: 2rem;
  }
  h2
  {
color:rgb(126, 117, 117);
text-align: center;
font-weight: bold;
font-size: 1.5rem;
  }
  .pdfstyle
  {
    width: 75px;
    height: 100px;
  }
.descargando
{

}
</style>


